module.exports = __webpack_public_path__ + "img/remind.317ff441.png";